import { lazy } from "react";

const POS = lazy(() => import("../Sales/POS/POS"));
const CashSalesInvoice = lazy(() =>
  import("../Sales/CashSalesInvoice/CashSalesInvoice")
);
const CashSalesInvoiceList = lazy(() =>
  import("../Sales/CashSalesInvoice/List/CashSalesInvoiceList")
);
const ViewCashSalesInvoice = lazy(() =>
  import("../Sales/CashSalesInvoice/View/ViewCashSalesInvoice")
);
const Status = lazy(() => import("../Sell/Status/Status"));
const Quotes = lazy(() => import("../Sales/POS/QuoteSale/Quotes/Quotes"));
const SalesHistory = lazy(() => import("../Sell/SaleHistory/SalesHistory"));
const SellReturnForm = lazy(() =>
  import("../Sales/SaleReturn/SellReturnForm")
);
const SaleReturns = lazy(() =>
  import("../Sales/SaleReturn/List/SaleReturns")
);
const DirectReturnForm = lazy(() =>
  import("../Sales/DirectReturn/DirectReturnForm")
);
const ViewSellReturn = lazy(() =>
  import("../Sales/SaleReturn/ViewSellReturn")
);
const CloseReg = lazy(() =>
  import("../Sales/POS/Register/CloseReg/CloseReg")
);
// The register-closure detail report, exposed under a POS-scoped route so a
// cashier who can close registers can view the full details without needing
// separate Report access (the report copy lives at /view_register/:id and is
// gated by reportAccess). Same component, POS gate.
const RegisterDetails = lazy(() =>
  import("../Report/RegisterClosures/ViewRegister/ViewRegister")
);
// Counter stock write-off — the cashier-scoped mini Inventory Adjustment covering
// wastage, damaged, expired and lost stock. Lives under Sales, not Inventory,
// because it is a till-side action gated on its own flag; the back-office form
// stays at /inventory_adjustment_form on inventoryAdjustmentAccess.
const StockWriteOffList = lazy(() =>
  import("../Sales/StockWriteOff/List/StockWriteOffList")
);
const StockWriteOffForm = lazy(() =>
  import("../Sales/StockWriteOff/Form/StockWriteOffForm")
);
const CommissionSetup = lazy(() =>
  import("../Sales/Commission/Setup/CommissionSetup")
);
const CommissionReport = lazy(() =>
  import("../Sales/Commission/Report/CommissionReport")
);

export const salesRoutes = (access, settings) => [
  { path: "/pos/*", element: POS, title: "pos", enabled: settings?.fiscalYearId && access.posAccess },
  { path: "/cash_sales_invoice", element: CashSalesInvoiceList, title: "cashSalesInvoice", enabled: settings?.fiscalYearId && access.cashSalesInvoiceAccess },
  { path: "/cash_sales_invoice/new", element: CashSalesInvoice, title: "newCashSalesInvoice", enabled: settings?.fiscalYearId && access.cashSalesInvoiceAccess && (access.cashSalesInvoice?.create ?? true) },
  { path: "/cash_sales_invoice/view/:id", element: ViewCashSalesInvoice, title: "viewCashSalesInvoice", enabled: settings?.fiscalYearId && access.cashSalesInvoiceAccess },
  { path: "/status", element: Status, title: "status", enabled: settings?.fiscalYearId && access.status },
  { path: "/quotes", element: Quotes, title: "quotes", enabled: settings?.fiscalYearId && access.pos?.quote },
  { path: "/sales_history", element: SalesHistory, title: "salesHistory", enabled: settings?.fiscalYearId && access.salesHistoryAccess },
  { path: "/sales_history/:customerId", element: SalesHistory, title: "salesHistory", enabled: settings?.fiscalYearId && access.salesHistoryAccess },
  { path: "/sell_return_form/:invoiceId", element: SellReturnForm, title: "saleReturnForm", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/sale_returns", element: SaleReturns, title: "saleReturns", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/view_sale_return/:id", element: ViewSellReturn, title: "viewSaleReturn", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/direct_return", element: DirectReturnForm, title: "directReturn", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/close_reg", element: CloseReg, title: "closeRegister", enabled: settings?.fiscalYearId && access.pos?.registerClosing },
  { path: "/register_details/:id", element: RegisterDetails, title: "viewRegister", props: { expandByDefault: true }, enabled: settings?.fiscalYearId && access.pos?.registerClosing },
  { path: "/stock_write_off", element: StockWriteOffList, title: "stockWriteOff", enabled: settings?.fiscalYearId && access.wastageAccess },
  { path: "/stock_write_off_form", element: StockWriteOffForm, title: "newStockWriteOff", enabled: settings?.fiscalYearId && access.wastageAccess && (access.wastageNav?.create ?? true) },
  { path: "/stock_write_off_form/:id", element: StockWriteOffForm, title: "stockWriteOffDetails", enabled: settings?.fiscalYearId && access.wastageAccess },
  { path: "/commission_setup", element: CommissionSetup, title: "commissionSetup", enabled: settings?.fiscalYearId && access.commissionAccessNav?.setup },
  { path: "/commission_report", element: CommissionReport, title: "commissionReport", enabled: settings?.fiscalYearId && access.commissionAccessNav?.report },
];
